/**
 * @param {string} key
 * @param {object} data
 * @param {string} [data.activeView]
 * @param {string|object} [data.selectedCategoryId]
 * @param {boolean} [data.isCardView]
 * @param {number} [data.limit] 페이지네이션 기본 Views
 */
export function saveViewInfo(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
}

export function loadViewInfo(key, stageId, projectId) {
    try {
        const objectString = localStorage.getItem(key);
        const jsonObj = JSON.parse(objectString);
        if (jsonObj.stageId === stageId && jsonObj.projectId === projectId) return jsonObj;
    } catch {
        // ignored
    }
    return null;
}
